import angular from 'angular';

/**
 * Base class for Models used to help serialize and validate data for api submission.
 */

export class BaseModel {

    /**
     * Create a new Model.
     * 
     * @param Array<String> required - the list of required field for basic validation. default: []
     * @param Object initializer - object containing initial state for the model. default: {}
     */
    constructor(required, initializer) {
        this._required = (required) ? angular.copy(required) : [];
        initializer = (initializer) ? angular.copy(initializer) : {};
        if (initializer.hasOwnProperty('_required')) {
            throw new TypeError(this.constructor.name + '.' + '_required is a reserved property and cannot be set via a model initializer');
        }
        angular.extend(this, initializer);
    }

    /**
     * generate a console.log message with the class name as a pre-amble to help with debugging.
     */
    log() {
        console.log(this.constructor.name, ...arguments);
    }

    /**
     * convert a date Object to an YYYY-MM-DD string.
     * @param Object data - date to be converted.
     * @return String - 'YYYY-MM-DD' formatted date.
     */
    serializeDropdownDate(data) {
        if (data.hasOwnProperty('day') && data.hasOwnProperty('month') && data.hasOwnProperty('year')) {
            let date = new Date(data.year, data.month, data.day);
            date = new Date(date - (date.getTimezoneOffset() * 60000));
            return date.toISOString().substr(0,10);
        } else {
            return null;
        }
    }

    /**
     * serialize fields of the Model. 
     */
    serialize() {
        this.validate();
        let serialized = {};
        angular.extend(serialized, this);
        delete serialized['_required'];
        return serialized;
    }

    /**
     * Validate the fields of the model. 
     */
    validate() {
        this._required.forEach((required_property) => {
            if (
                required_property === 'birth_date' &&
                this.isJuvenileLifeProduct === true &&
                (!this.birth_date || this.birth_date.year === null)
            ) {
                return;
            }
            if (!this.hasOwnProperty(required_property) || this[required_property] === null) {
                throw new Error(this.constructor.name + '.' + required_property +' is required')
            }
        });
    }
};

export default BaseModel;


// WEBPACK FOOTER //
// ./app/jangl/BaseModel.js